<div class="container">
    <button class="button-undecorated close-button" [attr.aria-label]="'Close Verify Email Modal'" (click)="closeModal()">
        <cwo-round-icon [iconName]="iconNameType.close" [size]="'medium'" />
    </button>
    <img
        src="../../../assets/icons/verifyemail.png"
        [alt]="'Verify Email Image'" class="icon" />
    <div class="main-content">
        <cwo-feedback-text [type]="feedbackType" [text]="feedbackText"></cwo-feedback-text>
        <span class="title">{{'modals.verify_email.title' | transloco}}</span>
        <span class="subtitle">{{'modals.verify_email.subtitle.first' | transloco}}<span class="highlight">{{accountEmail()}}</span><br/>{{'modals.verify_email.subtitle.second' | transloco}}</span>
    </div>
    <button class="button button-clear resend-button full-width" (click)="resendVerificationEmail()"><cwo-icon  class="icon-container" [class.rotating]="loading" size="1.5rem" [name]="iconNameType.refresh" /> {{'modals.verify_email.resend' | transloco}}</button>
</div>